import { router } from './router';

export function buildRouteUrl({ name, path, data } = {}) {
    if (path) {
        return path;
    }
    return router.generate(name, data);
}

export function getRouter() {
    return router;
}

export const withRouting = () => (superClass) =>
    class extends superClass {
        static get properties() {
            return {
                activeRoute: { type: String },
                name: { type: String },
                path: { type: String },
                data: { type: Object },
            };
        }

        firstUpdated(changedProperties) {
            this.addEventListener('click', this.handleClick);
        }

        handleClick(e) {
            e.preventDefault();
            e.stopPropagation();
            if (e.metaKey) {
                const link = e.currentTarget.shadowRoot.querySelector('a');
                window.open(link.href, '_blank');
            } else {
                this._fireRoutedItemEvent(e);
                const url = buildRouteUrl(this);
                router.navigate(url);
            }
        }

        _fireRoutedItemEvent(e) {
            const event = new CustomEvent('tmn-routed-item-click', {
                detail: { originalEvent: e },
                bubbles: true,
                composed: true,
            });
            this.dispatchEvent(event);
        }

        buildUrl() {
            let url = false;
            try {
                url = buildRouteUrl(this);
            } catch (error) {
                console.warn('failed to build url');
            }
            return url;
        }
    };
